import AppBar from './components/appbar';
import Button from './components/button';
import Container from './components/container';
import CssBaseline from './components/cssBaseline';
import Dialog from './components/dialog';
import Icon from './components/icon';
import Input from './components/input';
import Menu from './components/menu';
import Tabs from './components/tabs';
import Toolbar from './components/toolbar';

export default [AppBar, Button, Container, CssBaseline, Dialog, Icon, Input, Menu, Tabs, Toolbar];
